import { Tab } from 'semantic-ui-react';

export default Tab;
